<template>
  <div class="page-container">
    <div class="query-title">订单明细查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="apply" tip="货款校验" @click="soHkCheck" />
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="500"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ height: 27,isCurrent: true }"
            :scroll-y="{ enabled: false }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #object_id="{ row }">
              <span class="blue" @click="goOrderDetail(row)">{{ row.object_id }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { getOrderDetailList, soHkCheck } from '@/api/sap/order-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/salesOrderDetailList'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.gridOptions.columns = [
      { type: 'checkbox', width: 60, fixed: 'left', align: 'center' }
    ]
    this.initPage(pageConfig)
    if (this.$store.getters.role.ROLE === 'WLY001') {
      this.queryData(1)
    }
  },
  activated() {
    this.queryData(this.pagination.page, this.$refs.QueryParams.sub())
  },
  methods: {
    async soHkCheck() {
      const selectRecords = this.$refs.xTable.getCheckboxRecords()
      if (selectRecords.length === 0) {
        this.$message.warning('请选择需要校验的订单！')
        return
      }

      const data = selectRecords.map(item => ({ objrct_id: item.object_id }))

      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role_id: this.$store.getters.role.ROLE,
        data: data
      }

      this.loading = true
      try {
        const res = await soHkCheck(params)
        if (res.msgtype === 'S') {
          this.$message.success(res.message)
          // 刷新数据
          this.queryData(this.pagination.page)
        } else {
          this.$message.error(res.message)
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    goOrderDetail(row) {
      const config = {
        ZS01: '/wly/order/order-quota-check',
        ZS02: '/wly/order/order-noquota-check',
        ZS03: '/wly/order/order-batch-ticket-check',
        ZS04: '/wly/order/order-atmosphere-check',
        ZS05: '/wly/order/order-terminal-group-check',
        ZS06: '/wly/order/order-group-buy-check'
      }

      let path = ''

      if (row.process_type === 'ZS02' && row.zzfld00002j === 'V014') {
        path = config['ZS05']
      } else if (row.process_type === 'ZS02' && (row.zzfld00002j === 'V013' || row.zzfld00002j === 'V015')) {
        path = config['ZS06']
      } else {
        path = config[row.process_type]
      }

      this.$router.push({
        path: path,
        query: {
          object_id: row.object_id
        }
      })
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        // 保存 查询组件的查询参数
        if (ranges) {
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await getOrderDetailList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    async exportExcel() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getOrderDetailList)
      frontExport(this.gridOptions.columns, data, '订单明细')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/views/order-manage/salesOrderDetailList.vue